import { useState } from "react";
import { History, Facebook, ExternalLink } from "lucide-react";

const TABS = [
  { key: "trends", label: "Historique des tendances" },
  { key: "pubs", label: "Publications Facebook" },
];

function dateFmt(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("fr-FR", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function HistoryTabs({ allTrends, publishedVideos }) {
  const [tab, setTab] = useState("trends");

  return (
    <section className="card-surface p-6" data-testid="history-section">
      <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <History className="w-4 h-4 text-[color:var(--bcs-text-mut)]" />
          <h2 className="font-display text-xl font-bold">Journal</h2>
        </div>
        <div className="flex gap-1 bg-[#f7f8fa] border border-[#dddfe2] rounded-lg p-1">
          {TABS.map(t => (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
                tab === t.key
                  ? "bg-[#e7f3ff] text-[#1877f2]"
                  : "text-[color:var(--bcs-text-mut)] hover:text-[#1877f2]"
              }`}
              data-testid={`history-tab-${t.key}`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {tab === "trends" && (
        <div className="overflow-x-auto scroll-x">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10.5px] font-mono-ui tracking-widest uppercase text-[color:var(--bcs-text-dim)] border-b border-[#dddfe2]">
                <th className="py-2 pr-4">Date</th>
                <th className="py-2 pr-4">Source</th>
                <th className="py-2 pr-4">Sujet</th>
                <th className="py-2 pr-4">Créateur</th>
                <th className="py-2 pr-4 text-right">Score</th>
              </tr>
            </thead>
            <tbody>
              {allTrends.length === 0 && (
                <tr><td colSpan="5" className="py-8 text-center text-[color:var(--bcs-text-mut)]">Aucune tendance enregistrée.</td></tr>
              )}
              {allTrends.map(t => (
                <tr key={t.id} className="border-b border-[#e4e6eb] hover:bg-[#f2f3f5]">
                  <td className="py-2.5 pr-4 font-mono-ui text-xs text-[color:var(--bcs-text-mut)]">{dateFmt(t.created_at)}</td>
                  <td className="py-2.5 pr-4">
                    <span className={`chip ${t.source === "TikTok" ? "chip-tt" : "chip-fb"}`}>{t.source}</span>
                  </td>
                  <td className="py-2.5 pr-4 max-w-[320px]">
                    <div className="truncate font-medium">{t.title}</div>
                    <div className="truncate text-xs text-[color:var(--bcs-text-dim)]">{t.hook}</div>
                  </td>
                  <td className="py-2.5 pr-4 font-mono-ui text-xs text-[color:var(--bcs-text-mut)]">{t.creator_handle}</td>
                  <td className="py-2.5 pr-4 text-right font-mono-ui font-bold text-[color:var(--bcs-accent)]">{t.viral_score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === "pubs" && (
        <div className="space-y-3">
          {publishedVideos.length === 0 && (
            <div className="py-10 text-center text-[color:var(--bcs-text-mut)]">
              <Facebook className="w-10 h-10 mx-auto opacity-40" />
              <div className="font-mono-ui text-xs tracking-widest uppercase mt-3">Aucune publication</div>
              <p className="text-sm mt-1">Marque une vidéo prête comme "Publiée FB" pour l'ajouter ici.</p>
            </div>
          )}
          {publishedVideos.map(v => (
            <div
              key={v.id}
              className="flex items-center gap-4 rounded-lg border border-[#dddfe2] bg-[#f7f8fa] p-3"
              data-testid={`pub-row-${v.id}`}
            >
              <div className="w-14 h-14 rounded-md overflow-hidden bg-black shrink-0">
                {v.video_url ? (
                  <video src={v.video_url} muted className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-xs text-[color:var(--bcs-text-dim)]">—</div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium text-sm truncate">{v.trend_title || v.prompt.slice(0, 60)}</div>
                <div className="text-xs text-[color:var(--bcs-text-mut)] mt-0.5 font-mono-ui">
                  Publiée le {dateFmt(v.published_at)} · {v.duration_sec}s · {v.model.toUpperCase()}
                </div>
              </div>
              <a
                href="https://www.facebook.com/profile.php?id=100083285157404"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-sharp"
              >
                <ExternalLink className="w-3.5 h-3.5" />
                Page FB
              </a>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
